<script>
import yoliBanner from '@oppobrowser/lib-browser-yoliBanner';

export default {
  data() {
    return {
      isShowTip: false,
      isHeytapPhone: false,
    }
  },

  created() {
    this.isShowTip = yoliBanner.isShowTip;
    this.isHeytapPhone = yoliBanner.isHeytapPhone;
  },

  methods: {
    setCookie(c_name, value, expiredays) {
      const exdate = new Date()
      exdate.setDate(exdate.getDate() + expiredays)
      document.cookie = c_name + '=' + escape(value) + ((expiredays==null) ? '' : ';expires=' + exdate.toGMTString())
    },

    getCookie(c_name) {
      if(document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + '=')
        if (c_start != -1) {
          c_start=c_start + c_name.length + 1
          let c_end = document.cookie.indexOf(';', c_start)
          if(c_end == -1) {
            c_end = document.cookie.length
          }

          return unescape(document.cookie.substring(c_start, c_end))
        }
      }
      return ''
    },
  }
};
</script>
